export default __webpack_public_path__ + "static/media/02-weather-dashboard-main.69f1876c.PNG";